<template lang="pug">
  WtEntityTable.teams-table(
    :title="title"
    entityType="team"
    :show-title="showTitle"
    :data="teamsData"
    default-sort-field="name"
    :enable-search="enableSearch"
    :search-fields="searchFields"
    :enable-remove="enableRemove"
    :enable-add="enableAdd"
    :includeByType="includeByType"
    @remove="unstageTeam($event)"
    @add="stageTeam($event)"
    :empty-message="emptyMessage"
  )
    BTableColumn(field="name" label="Team Name" sortable v-slot="column")
      | {{ column.row.name }}
    BTableColumn(field="numMembers" label="# of Members" centered v-slot="column")
      | {{ column.row.numMembers }}
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import tablePropsMixin from "@/mixins/tablePropsMixin";
import WtEntityTable from "@@/WtEntityTable/WtEntityTable";

const STATIC = "static";
const API = "api";
const RECEIVER = "receiver";

export default {
  name: "ChallengeBuilderTeamsTable",

  components: { WtEntityTable },

  mixins: [tablePropsMixin],

  props: {
    /**
     * set as `api` to fetch teams to populate table, set as `receiver`
     * to allow teams to be added to table
     */
    mode: {
      type: String,
      default: "api",
      validator(mode) {
        return [STATIC, API, RECEIVER].indexOf(mode) !== -1;
      }
    },

    title: {
      type: String,
      default: "Team List:"
    },

    includeByType: {
      type: String,
      default: "invite"
    },

    notInChallengeId: {
      type: Number,
      default: 0
    },

    emptyMessage: {
      type: String,
      default: "No teams have been added yet"
    }
  },

  data() {
    return {
      teamsData: []
    };
  },

  computed: {
    ...mapGetters("program", ["programTeams"]),
    ...mapGetters("challengeBuilder", ["stagedTeams"])
  },

  async mounted() {
    if (this.mode === STATIC) {
      await this.fetchProgramTeams({
        all: 1,
        notInChallengeId: this.notInChallengeId
      }).then(response => {
        this.teamsData = response.data;
      });
    } else if (this.mode === API) {
      await this.fetchProgramTeams();
      this.teamsData = this.programTeams;
    } else {
      this.teamsData = this.stagedTeams;
    }
  },

  methods: {
    ...mapActions("challengeBuilder", ["unstageTeam", "stageTeam"]),
    ...mapActions("program", ["fetchProgramTeams"])
  }
};
</script>

<style lang="sass">
.teams-table
  .team-td
    max-width: 150px
</style>
